import {LandingAccordion, LandingAccordionItem} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import {FAQPageJsonLd} from 'next-seo';

export type Article = {title: string; answer: string[]; html?: true};
export const LandingSeoFaq: React.FC<
	React.PropsWithChildren<{articles: Article[]}>
> = ({articles, children}) => {
	const {t} = useTranslation();
	return (
		<>
			<LandingAccordion
				defaultIndex={[0]}
				title={t('generic_title_faq_standalone-features', {ns: 'common'})}
			>
				{children}
				{articles.map(({title, answer, html}) => (
					<LandingAccordionItem label={title} key={title} titleTag="h3">
						{answer.map((text) =>
							html ? (
								<span
									key={text}
									dangerouslySetInnerHTML={{
										__html: text,
									}}
								/>
							) : (
								text
							),
						)}
					</LandingAccordionItem>
				))}
			</LandingAccordion>
			<FAQPageJsonLd
				mainEntity={articles.map((item) => ({
					questionName: item.title,
					acceptedAnswerText: item.answer.join(' ').replace(/"/g, '\\"'),
				}))}
			/>
		</>
	);
};
